import { compact, find, isEmpty, kebabCase, map, reject } from 'lodash/fp';
import { TabGroup } from '@ahmdigital/ui';
import { useState } from 'react';

import { CompareCoverGroup, InsuranceGroup } from '../../../types';
import { FootnoteType } from '../../../../../types/footnote';
import { SellingPointGroup } from '../../../../../types/explained';
import CompareCover from '../compare-cover';
import InclusionsPanel from '../panel';
import styles from '../styles.module.sass';

const TabGroupPanels = ({
  groups,
  footnote,
}: {
  groups: (CompareCoverGroup | InsuranceGroup | SellingPointGroup)[];
  footnote?: FootnoteType;
}) => {
  const defaultGroup = groups && groups.length > 2 ? groups[1] : groups[0];
  const [value, setValue] = useState(kebabCase(defaultGroup?.tabTitle ?? ''));

  if (isEmpty(groups) || groups.length === 1) {
    return null;
  }

  const groupsToMap = reject({ id: 'compare' }, groups) as SellingPointGroup[];
  const productPanels = map(
    (group: SellingPointGroup) => ({
      panel: <InclusionsPanel key={group.tabTitle} {...group} footnote={footnote} isPortableTextDescription />,
      text: group.tabTitle,
      value: kebabCase(group.tabTitle ?? ''),
    }),
    groupsToMap,
  );

  const compare = find({ id: 'compare' }, groups) as CompareCoverGroup;
  const comparisonPanel = compare && {
    panel: <CompareCover {...compare} />,
    text: compare.tabTitle,
    value: kebabCase(compare.tabTitle),
  };

  const tabGroupOptions = compact([...productPanels, comparisonPanel]);

  return (
    <TabGroup
      tabListVariant={styles.tabList}
      input={{
        onChange: setValue,
        value,
      }}
      isHeading
      options={tabGroupOptions}
    />
  );
};

export default TabGroupPanels;
